<template>
  <div class="bg-white h-24 w-full animate-pulse rounded"></div>
</template>

<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({ name: 'EditorLoader' })
</script>
